import React, {memo, useState, useEffect, useCallback } from 'react';
import { makeStyles } from '@mui/styles'
import { MenuItem, Select,FormControl,TextField, Typography} from '@mui/material';
import { ReactComponent as DropDownIcon } from "../../assets/icons/icon-angle-down.svg"
import QuickFilterCondition from './QuickFilterCondition';

const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "100%"
    },
    menuDropdownItem: {
        fontSize: '14px',
        color: '#202124',
        '&:hover': {
            backgroundColor: '#f6f6f6'
        }
    }
}))

const QuickFilterForm = ({field,index,onChangeFilter}) => {
    const classes = useStyles();
    //const [listType,setListType] = useState(field.listType)
    const [conditions,setFilterCondition] = useState(field.conditions)

    const onAddCondition = useCallback((e) => {
        setFilterCondition(prevState => [...prevState,{label:null,operator:"",values:[]}])
    })

    const onConditionChange = useCallback((e,type,i) => {
        //console.log(e,type,i)
        let conditionObj = conditions[i]
        let propValue = e.target.value
        switch(type){
            case 'operator':
                conditionObj.operator = propValue
                break;
            case 'values':
                conditionObj.values = propValue.split('\n')
                break;
            case 'date':
                conditionObj.values = propValue
                break;
            default:
                conditionObj.label = propValue
        }
        //console.log(conditionObj)
        setFilterCondition(prevState => {
            prevState.splice(i,1,conditionObj)
            return [...prevState]
        })
    })

    const onDeleteCondition = useCallback((i) => {
        setFilterCondition(prevState => {
            prevState.splice(i,1)
            return [...prevState]
        })
    })

    useEffect(() => {
        onChangeFilter(conditions,index,'conditions')
    },[conditions])

    return <>
        <FormControl variant="outlined" className={classes.formControl}>
            <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >Label</Typography>
            <TextField
                className="report_form_ui_input text-small"
                id={"quick-filter-member-label-" + field.member + "-" + index}
                label=""
                value={field.label ?? ''}
                onChange={e => onChangeFilter(e,index,'label')}
                variant="outlined"
                size='small'
            />
        </FormControl>
        <Typography className="text-small" variant="body2" sx={{ paddingBottom: '0.2rem' }} >List Type</Typography>
        <Select
            variant="outlined"
            className="report_form_ui_input_select text-small pl-0"
            id={'listType'}
            value={field.listType}
            defaultValue='SingleSelect'
            onChange={e => onChangeFilter(e,index,'listType')}
            size='small'
            IconComponent={DropDownIcon}
            MenuProps={{
                classes: {
                    root: `form-select-menu`
                }
            }}
        >
            <MenuItem value='SingleSelect'>Single Select</MenuItem>
            <MenuItem value='Multiselect'>Multi Select</MenuItem>
        </Select>
        {conditions && <QuickFilterCondition onAddCondition={onAddCondition} onDeleteCondition={onDeleteCondition} onConditionChange={onConditionChange} fieldType={field.type} filterConditions={conditions}/>} 
    </>
}

export default memo(QuickFilterForm)